import { render } from "./TrainingUnitComponent.vue?vue&type=template&id=18d9a54e&scoped=true"
import script from "./TrainingUnitComponent.vue?vue&type=script&lang=js"
export * from "./TrainingUnitComponent.vue?vue&type=script&lang=js"

import "./TrainingUnitComponent.vue?vue&type=style&index=0&id=18d9a54e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d9a54e"]])

export default __exports__